import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetStatus } from '../../../../state';

const InstallDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetStatus({ installDate: event.target.value }));
  };

  return (
    <TextField
      label="Install Date"
      size="small"
      type="date"
      fullWidth
      InputLabelProps={{ shrink: true }}
      value={currentAsset?.installDate ? currentAsset.installDate.substring(0, 10) : ''}
      onChange={handleChange}
    />
  );
};

export default InstallDateEdit;
